/* eslint-disable react/prop-types */
import React from "react";
import { Typography, makeStyles, Box } from "@material-ui/core";
import { BsArrowUp } from "react-icons/bs";

const useStyles = makeStyles(() => ({
  mainContainer: {
    width: "100%",
    minWidth: "120px",
  },
  titleText: {
    color: "#646464",
  },
  percentageContainer: {
    display: "flex",
    flexDirection: "row",
  },
  valueText: {
    fontSize: "15px",
    fontWeight: "bold",
  },
  percetangePositive: {
    fontSize: "15px",
    fontWeight: "bold",
    color: "#5AB793",
    paddingLeft: "15px",
  },
  percetangeNegative: {
    fontSize: "15px",
    fontWeight: "bold",
    color: "#FD6464",
    paddingLeft: "15px",
  },
}));
export default function ScenarioCardValueItem({
  text,
  percentageUnits = "%",
  value,
  percentage = null,
}) {
  const classes = useStyles();
  return (
    <Box className={classes.mainContainer}>
      <Typography variant="body1" className={classes.titleText}>
        {text}
      </Typography>
      <Box className={classes.percentageContainer}>
        <Typography variant="body1" className={classes.valueText}>
          {value}
        </Typography>
        {percentage !== null && (
          <Typography
            variant="body1"
            className={
              percentage >= 0
                ? classes.percetangePositive
                : classes.percetangeNegative
            }
          >
            <BsArrowUp
              size={11}
              strokeWidth={1.5}
              style={{
                marginRight: "1px",
                transform: `rotateX(${percentage >= 0 ? "0deg" : "180deg"})`,
              }}
            />
            {percentage}
            {percentageUnits}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
